import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class SubjectResultApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'subject-result'
    }


 

}
